import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import React from 'react';
import RefundAskIcon from '../../../svg-icons/RefundAskIcon';
import LoadingButton from '../../../utils/common/LoadingButton';

const DialogBox = ({
  isLoading,
  refund,
  isOpen,
  setIsOpen,
  action,
  refusedDescription,
  setRefusedDescription,
  handleSubmit,
}) => {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle
        sx={{
          borderBottom: 1,
          marginBottom: 3,
          backgroundColor: 'info.main',
          display: 'flex',
          gap: 4,
          alignItems: 'center',
          fontSize: 24,
          width: 500,
        }}
      >
        <RefundAskIcon />
        Remboursement
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            color: 'primary.dark',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          Souhaitez-vous vraiment {action?.label}?
          <Box sx={{ display: 'flex', flexDirection: 'column', marginLeft: 2 }}>
            <Typography component="span">
              Ticket:{' '}
              <Typography component="span" sx={{ fontWeight: 'bold' }}>
                {refund.ticket.reference}
              </Typography>
            </Typography>
            <Typography component="span">
              Commande:{' '}
              <Typography component="span" sx={{ fontWeight: 'bold' }}>
                {refund.order?.reference || '--'}
              </Typography>
            </Typography>
            <Typography component="span">
              Client:
              <Typography component="span" sx={{ fontWeight: 'bold' }}>
                {' '}
                {refund.firstName} {refund.lastName}
              </Typography>
            </Typography>
            <Typography component="span">
              Montant à rembourser:{' '}
              <Typography component="span" sx={{ fontWeight: 'bold' }}>
                {refund.amountToRefund}
                {getSymbolFromCurrency(
                  refund.ticket.contact.store.country.currency.code
                )}
              </Typography>
            </Typography>
          </Box>
        </DialogContentText>

        {action?.requireDescription && (
          <TextField
            autoFocus
            required
            margin="dense"
            label="Description"
            value={refusedDescription}
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) => setRefusedDescription(e.target.value)}
            helperText="Motif - 10 caractères minimum"
          />
        )}
      </DialogContent>

      <DialogActions sx={{ display: 'flex', justifyContent: 'space-around' }}>
        <Button
          variant="outlined"
          color="error"
          onClick={() => setIsOpen(false)}
        >
          Annuler
        </Button>
        <LoadingButton
          isLoading={isLoading}
          variant="contained"
          color="success"
          onClick={handleSubmit}
          disabled={
            (action?.requireDescription && refusedDescription.length < 10) ||
            isLoading
          }
        >
          {action?.label}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DialogBox;
